module.exports = __webpack_public_path__ + "img/citrix.7eace472.jpg";